import { fallback, object, string, type InferInput } from 'valibot';

export type OTTranslations = InferInput<typeof otTranslationsSchema>;

export const otTranslationsSchema = object({
  homepage: object({
    footer: object({
      cta: object({
        cars: object({
          description: fallback(string(), 'homepage.footer.cta.cars.description'),
          headline: fallback(string(), 'homepage.footer.cta.cars.headline'),
          showAllVehicles: fallback(string(), 'homepage.footer.cta.cars.showAllVehicles'),
        }),
        vans: object({
          description: fallback(string(), 'homepage.footer.cta.vans.description'),
          headline: fallback(string(), 'homepage.footer.cta.vans.headline'),
          showAllVehicles: fallback(string(), 'homepage.footer.cta.vans.showAllVehicles'),
        }),
      }),
    }),
  }),
});
